import { render, staticRenderFns } from "./CustomMenu.vue?vue&type=template&id=4c2b6cf2&scoped=true&"
import script from "./CustomMenu.vue?vue&type=script&lang=js&"
export * from "./CustomMenu.vue?vue&type=script&lang=js&"
import style0 from "./CustomMenu.vue?vue&type=style&index=0&id=4c2b6cf2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c2b6cf2",
  null
  
)

export default component.exports